import { Country } from '../models/city';
import { Locales } from './locales';

export const CountryLocalization = {
  [Locales.ru]: {
    [Country.RU]: 'Россия',
    [Country.BL]: 'Беларусь',
    [Country.AM]: 'Армения',
    [Country.KZ]: 'Казахстан',
    [Country.KG]: 'Кыргызстан',
    [Country.USA]: 'США',
    [Country.GE]: 'Грузия',
    [Country.AZ]: 'Азербайджан',
    [Country.CHN]: 'Китай',
    [Country.EGY]: 'Египет',
    [Country.IRN]: 'Иран',
    [Country.GRC]: 'Греция',
    [Country.UZB]: 'Узбекистан',
  },
  [Locales.en]: {
    [Country.RU]: 'Russia',
    [Country.BL]: 'Belarus',
    [Country.AM]: 'Armenia',
    [Country.KZ]: 'Kazakhstan',
    [Country.KG]: 'Kyrgyzstan',
    [Country.USA]: 'USA',
    [Country.GE]: 'Georgia',
    [Country.AZ]: 'Azerbaijan',
    [Country.CHN]: 'China',
    [Country.EGY]: 'Egypt',
    [Country.IRN]: 'Iran',
    [Country.GRC]: 'Greece',
    [Country.UZB]: 'Uzbekistan',
  },
};
